import { SimpleGrid, Text, Paper, Stack, Divider } from '@mantine/core';
import { useOrganization } from '$/contexts/org.ctx.tsx';
import { useState, useEffect } from 'react';

export default function OrgInfoGrid() {
    const { orgPlan, orgStats } = useOrganization();
    const [orgBks, setOrgBks] = useState<{ label: string, value: string, unit?:string }[]>([]);

    useEffect(() => {
        if(orgPlan && orgStats){
            const hp = orgPlan.history.split('-');
            setOrgBks([
                { label: 'Seats', value: `${orgStats.activeSeats}  / ${orgStats.invitedSeats}  / ${orgPlan.seatLimit}`, unit: 'Active / Invited / Limit' },
                { label: 'Team Distro', value: `${orgStats.totalTeams} / ${orgStats.soloUsers}`, unit: 'Teams / Solo Users' },
                { label: 'Last 30 Days', value: `${orgStats.testsIn30}`, unit: 'Tests' },
                { label: 'History Access', value: hp[0], unit: hp[1].toLocaleUpperCase() },
            ]);
        }
    }, [orgPlan, orgStats])

    return (
        <SimpleGrid cols={{base: 2, md: 3, xl: 4}}>
            {orgBks.map((bk, i) => (
                <Paper key={`${bk.label}-${i}`} p={'sm'} withBorder shadow="md">
                    <Stack ta={'center'} gap={8}>
                        <Text size='1.5rem' fw={700}>{bk.value}</Text>
                        {!!bk.unit ? <Text size='0.65rem' c={'dimmed'}>{bk.unit}</Text> : <div> </div>}
                        <Divider />
                        <Text size='0.8rem' >{bk.label}</Text>
                    </Stack>
                </Paper>
            ))}
        </SimpleGrid>
    );
}
